import { camelCase, get, set } from 'lodash';
import {
  actions,
  state as stateConstants,
  status as statusConstants,
} from 'src/constants';

import * as reducerConstants from './constants';

const INITIAL_STATE = {};

const asyncActionTypes = [
  actions.ACTION_GET,
  actions.ACTION_CREATE,
  actions.ACTION_DELETE,
  actions.ACTION_UPDATE,
];

const statuses = [
  statusConstants.PENDING,
  statusConstants.SUCCESS,
  statusConstants.ERROR,
];

export const actionTypeRegExp = new RegExp(
  '@([A-Z0-9_]+)/' +
    `(${asyncActionTypes.join('|')})` +
    '_([A-Z_]+)_' +
    `(${statuses.join('|')})`
);

export default (state = INITIAL_STATE, action) => {
  const { type, response, error, dataPath } = action;

  if (!type) {
    return state;
  }

  const matchResult = type.match(actionTypeRegExp);

  if (!matchResult) {
    return state;
  }

  const [, namespace, , identifier, status] = matchResult;

  const storePath = [camelCase(namespace), camelCase(identifier)];
  const nextState = { ...state };

  if (status === statusConstants.PENDING) {
    return set(nextState, storePath, {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.PENDING,
      [reducerConstants.PROPERTY_FETCH_META]: {
        [reducerConstants.PROPERTY_IS_FETCHING]: true,
        [reducerConstants.PROPERTY_FETCHED]: false,
        [reducerConstants.PROPERTY_ERROR]: undefined,
      },
    });
  }

  if (status === statusConstants.SUCCESS) {
    const data = {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.SUCCESS,
      [reducerConstants.PROPERTY_DATA]: get(response, dataPath) || response,
      [reducerConstants.PROPERTY_FETCH_META]: {
        [reducerConstants.PROPERTY_IS_FETCHING]: false,
        [reducerConstants.PROPERTY_FETCHED]: true,
        [reducerConstants.PROPERTY_ERROR]: undefined,
      },
    };

    if (identifier === stateConstants.IDENTIFIER_TYPE_LIST.toUpperCase()) {
      data[reducerConstants.PROPERTY_TOTAL_ITEMS] =
        response.totalCount || response.data?.total;
    }

    return set(nextState, storePath, data);
  }

  if (status === statusConstants.ERROR) {
    return set(nextState, storePath, {
      [reducerConstants.PROPERTY_STATUS]: statusConstants.ERROR,
      [reducerConstants.PROPERTY_DATA]: undefined,
      [reducerConstants.PROPERTY_FETCH_META]: {
        [reducerConstants.PROPERTY_IS_FETCHING]: false,
        [reducerConstants.PROPERTY_FETCHED]: true,
        [reducerConstants.PROPERTY_ERROR]: error,
      },
    });
  }

  return state;
};
